import React from "react";

import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";


const EliminarNoticia = ({
    noticia,
    onVolver,
    onEliminar,
}) => {

    const handleEliminar = () => {

        if (!noticia?.id) {
            console.error("No existe una noticia válida para eliminar.");
            return;
        }

        onEliminar(noticia.id);
    };

    return (
        <Box
            sx={{
                maxWidth: "600px",
                mx: "auto",
                mt: 5,
            }}
        >

            <Card
                sx={{
                    borderRadius: 4,
                    boxShadow: "none",
                    border: "1px solid #E7EAF0",
                }}
            >

                <CardContent
                    sx={{
                        p: 4,
                        textAlign: "center",
                    }}
                >

                    <Box
                        sx={{
                            width: 70,
                            height: 70,
                            borderRadius: "50%",
                            backgroundColor: "#FFF0F0",
                            color: "#C62828",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mx: "auto",
                            mb: 3,
                        }}
                    >
                        <WarningAmberIcon
                            sx={{
                                fontSize: 38,
                            }}
                        />
                    </Box>

                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            color: "#22324A",
                            mb: 1,
                        }}
                    >
                        ¿Eliminar noticia?
                    </Typography>

                    <Typography
                        sx={{
                            color: "#7A828D",
                            mb: 2,
                        }}
                    >
                        Estás a punto de eliminar:
                    </Typography>

                    <Typography
                        sx={{
                            fontWeight: 700,
                            color: "#22324A",
                            mb: 2,
                        }}
                    >
                        "{noticia?.titulo}"
                    </Typography>

                    <Typography
                        sx={{
                            color: "#9A9FA8",
                            fontSize: "0.85rem",
                            mb: 4,
                        }}
                    >
                        Esta acción eliminará la noticia
                        del administrador.
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: 2,
                        }}
                    >

                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={onVolver}
                            sx={{
                                textTransform: "none",
                                color: "#666",
                            }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            variant="contained"
                            startIcon={<DeleteIcon />}
                            onClick={handleEliminar}
                            sx={{
                                backgroundColor: "#C62828",
                                textTransform: "none",
                                borderRadius: 2,

                                "&:hover": {
                                    backgroundColor: "#9E1F1F",
                                },
                            }}
                        >
                            Sí, eliminar
                        </Button>

                    </Box>

                </CardContent>

            </Card>

        </Box>
    );
};

export default EliminarNoticia;